import { StoreInterface } from "../../models";

export const getProfiles = (store: StoreInterface) => store.profiles?.profile;
